var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.8C11.0611 8.8 10.3 9.56112 10.3 10.5C10.3 11.4389 11.0611 12.2 12 12.2C12.9389 12.2 13.7 11.4389 13.7 10.5C13.7 9.56112 12.9389 8.8 12 8.8ZM8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.09998C9.26654 2.09998 6.7903 3.20906 4.99974 4.99962C3.20918 6.79018 2.1001 9.26641 2.1001 12C2.1001 14.7335 3.20918 17.2098 4.99974 19.0003C6.7903 20.7909 9.26654 21.9 12.0001 21.9C14.7337 21.9 17.2099 20.7909 19.0005 19.0003C20.791 17.2098 21.9001 14.7335 21.9001 12C21.9001 9.26641 20.791 6.79018 19.0005 4.99962C17.2099 3.20906 14.7337 2.09998 12.0001 2.09998ZM16.3825 18.8134C15.1752 17.8648 13.6542 17.3 12.0001 17.3C10.3459 17.3 8.82495 17.8648 7.61769 18.8134C8.8811 19.6279 10.385 20.1 12.0001 20.1C13.6152 20.1 15.1191 19.6279 16.3825 18.8134ZM6.27253 6.27241C7.73933 4.80561 9.76309 3.89998 12.0001 3.89998C14.2371 3.89998 16.2609 4.80561 17.7277 6.27241C19.1945 7.73921 20.1001 9.76297 20.1001 12C20.1001 14.1986 19.2253 16.1912 17.8027 17.6515C16.2452 16.3113 14.2167 15.5 12.0001 15.5C9.78351 15.5 7.75501 16.3113 6.19748 17.6515C4.7749 16.1912 3.9001 14.1986 3.9001 12C3.9001 9.76297 4.80574 7.73921 6.27253 6.27241ZM8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5ZM12 8.8C11.0611 8.8 10.3 9.56112 10.3 10.5C10.3 11.4389 11.0611 12.2 12 12.2C12.9389 12.2 13.7 11.4389 13.7 10.5C13.7 9.56112 12.9389 8.8 12 8.8Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleOutline);
export default __webpack_public_path__ + "static/media/user_circle_outline.4641e67917e977e705436ce32ce00d87.svg";
export { ForwardRef as ReactComponent };